<template>
    <el-dialog title="Vidéo Youtube" v-loading="loader" :visible.sync="display" width="50%">
        <div class="mb-3">Modifier les {{ items_selected }} produits selectionnés</div>
        <el-form class="formYoutube" ref="form" :model="form">
            <el-form-item prop="youtube_video">
                <el-input placeholder="Youtube ID" v-model="form.youtube_video"></el-input>
            </el-form-item>
        </el-form>
        <iframe v-if="form.youtube_video" width="560" height="315" :src="'https://www.youtube.com/embed/'+form.youtube_video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

        <span slot="footer" class="dialog-footer">
            <el-switch active-text="Syncronisé ?" v-model="sync" ></el-switch>
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {
                youtube_video: null
            },
            sync: false,
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var products = this.selected.map(v => v.id);
            this.loader = true;
            var datas = {
                products,
                youtube_video: this.form.youtube_video,
                mode: 'youtube',
                sync: this.sync
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            axios
                .post('/products/bulk', datas)
                .then(r => {
                    this.$emit('saved', r);
                    this.$refs.form.resetFields();
                    this.display = false;
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        }
    }
};
</script>
